export const serviceId = 'pces-jwv-user-tenant-onboarding-app';
